
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutorials/open-xd-file-flinto",
      function () {
        return require("private-next-pages/tutorials/open-xd-file-flinto.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutorials/open-xd-file-flinto"])
      });
    }
  